<template>
  <tr :class="{'v-data-table__mobile-table-row': isMobile}">
    <td v-if="!isMobile">
      {{ m(stay.date, $t("commonStrings.dateDisplayFormat")) }}
    </td>
    <td
      v-else
      class="v-data-table__mobile-row"
    >
      <div class="v-data-table__mobile-row__header">
        {{ $t("dietPanelStrings.stayTableHeaders.date") }}
      </div>
      <div
        class="v-data-table__mobile-row__cell"
      >
        {{ m(stay.date, $t("commonStrings.dateDisplayFormat")) }}
      </div>
    </td>
    <td
      v-if="!isMobile"
      class="truncated"
    >
      <span v-if="!durationIsOvernight && isEligible">{{ $t(`enums.dietLengthTypes.${lengthType}`) }}</span>
      <span v-else-if="!isEligible">{{ $t(`enums.dietDurationTypes.${stayDurationType}`) }}</span>
      <vee-field
        v-if="durationIsOvernight"
        v-slot="{componentField, errors}"
        v-model="stay.dietStayTypeId"
        :rules="stayTypeValidationRules"
        :name="$t('dietPanelStrings.stayTableHeaders.stayType')"
      >
        <v-select
          v-bind="componentField"
          :items="availableStayTypesDropdown"
          :error-messages="errors"
          item-value="id"
          name="stays"
          :placeholder="$t('dietPanelStrings.stayTableHeaders.stayType')"
          clearable
          density="compact"
          variant="outlined"
        >
          <template #append>
            <v-icon tag="span">
              mdi-menu-down
            </v-icon>
          </template>
          <template #item="data">
            {{ data.item.nameWithOrgs }}
          </template>
          <template #selection="data">
            {{ data.item.name }}
          </template>
        </v-select>
      </vee-field>
    </td>
    <td
      v-else
      class="v-data-table__mobile-row"
    >
      <div
        class="v-data-table__mobile-row__header"
      >
        {{ $t("dietPanelStrings.stayTableHeaders.stayType") }}
      </div>
      <div class="v-data-table__mobile-row__cell">
        <span
          v-if="!durationIsOvernight && isEligible"
        >{{ $t(`enums.dietLengthTypes.${lengthType}`) }}</span>
        <span v-else-if="!isEligible">{{ $t(`enums.dietDurationTypes.${stayDurationType}`) }}</span>
        <vee-field
          v-if="durationIsOvernight"
          v-slot="{componentField, errors}"
          v-model="stay.dietStayTypeId"
          :rules="stayTypeValidationRules"
          :name="$t('dietPanelStrings.stayTableHeaders.stayType')"
        >
          <v-select
            v-bind="componentField"
            :items="stayTypes"
            :error-messages="errors"
            name="stays"
            :placeholder="$t('dietPanelStrings.stayTableHeaders.stayType')"
            clearable
            variant="outlined"
            density="compact"
          />
        </vee-field>
      </div>
    </td>
    <td
      v-if="!isMobile"
      class="truncated"
    >
      <v-checkbox
        v-model="stay.hasNightAddition"
        color="primary"
        :label="$t('dietPanelStrings.stayTableHeaders.nightAddition')"
        :disabled="disabledNightAddition"
      />
    </td>
    <td
      v-else
      class="v-data-table__mobile-row"
    >
      <div
        class="v-data-table__mobile-row__header"
      >
        {{ $t("dietPanelStrings.stayTableHeaders.nightAddition") }}
      </div>
      <div class="v-data-table__mobile-row__cell">
        <v-checkbox
          v-model="stay.hasNightAddition"
          color="primary"
          :label="$t('dietPanelStrings.stayTableHeaders.nightAddition')"
          :disabled="disabledNightAddition"
        />
      </div>
    </td>
    <td
      v-if="!isMobile"
      class="text-right"
    >
      <amount-label :value="stay.amount" />
    </td>
    <td
      v-else
      class="v-data-table__mobile-row"
    >
      <div
        class="v-data-table__mobile-row__header"
      >
        {{ $t("dietPanelStrings.stayTableHeaders.amount") }}
      </div>
      <div class="v-data-table__mobile-row__cell">
        <amount-label :value="stay.amount" />
      </div>
    </td>
    <td
      v-if="!isMobile"
      class="truncated"
    >
      <v-select
        v-model="stay.dietDeductionIds"
        :items="deductionTypes"
        :placeholder="$t('dietPanelStrings.stayTableHeaders.meals')"
        multiple
        variant="outlined"
        density="compact"
        :disabled="disabledDeductions"
      />
    </td>
    <td
      v-else
      class="v-data-table__mobile-row"
    >
      <div
        class="v-data-table__mobile-row__header"
      >
        {{ $t("dietPanelStrings.stayTableHeaders.meals") }}
      </div>
      <div class="v-data-table__mobile-row__cell">
        <v-select
          v-model="stay.dietDeductionIds"
          :items="deductionTypes"
          :placeholder="$t('dietPanelStrings.stayTableHeaders.meals')"
          multiple
          variant="outlined"
          density="compact"
          :disabled="disabledDeductions"
        />
      </div>
    </td>
    <td v-if="!isMobile">
      <v-text-field
        v-model="stay.stayDescription"
        :placeholder="$t('dietPanelStrings.placeholders.description')"
        type="text"
        :disabled="!isEligible"
        variant="outlined"
        density="compact"
      />
    </td>
    <td
      v-else
      class="v-data-table__mobile-row"
    >
      <div
        class="v-data-table__mobile-row__header"
      >
        {{ $t("dietPanelStrings.stayTableHeaders.description") }}
      </div>
      <div class="v-data-table__mobile-row__cell">
        <v-text-field
          v-model="stay.stayDescription"
          :placeholder="$t('dietPanelStrings.placeholders.description')"
          type="text"
          :disabled="!isEligible"
          variant="outlined"
          density="compact"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import DietDeductionTypes from "@/enums/DietDeductionTypes";
import DietStayTypes from "@/enums/DietStayTypes";
import DietDurationTypes from "@/enums/DietDurationTypes";
import DietLengthTypes from "@/enums/DietLengthTypes";
import AmountLabel from "@/views/common/components/AmountLabel";
import { Field as VeeField } from "vee-validate";
import { toPercent } from "@/utils/numeric";
import deductionRates from "@/mixins/deductionRates";
import { calculateDietAmountForStay } from "@/utils/claims/diet";
import { filterAvailableClaimTypes } from "@/utils/claim";
import { m } from '@/plugins/moment';

export default {
  name: "DietStayRow",
  components: {
    AmountLabel,
    VeeField
  },
  mixins: [deductionRates],
  props: {
    stay: {
      type: Object,
      required: true
    },
    payingOrgs: {
      required: true,
      type: Array
    },
    stayDurationTypes: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: false
    },
    salaryFraction: {
      type: Boolean
    }
  },
  setup() {
    return { m };
  },
  computed: {
    availableStayTypes() {
      return filterAvailableClaimTypes(
        this.stay,
        "rateType",
        this.filterEnabledDietStayTypes,
        "enums.dietStayTypes",
        this.payingOrgs
      );
    },
    availableLengthTypes() {
      return filterAvailableClaimTypes(
        this.stay,
        "rateType",
        this.filterEnabledDietLengthTypes,
        "enums.dietLengthTypes",
        this.payingOrgs
      );
    },
    availableStayTypesDropdown() {
      return this.availableStayTypes.filter(
        x => x.id !== DietStayTypes.NightAddition
      );
    },
    hasValidNightAdditionRateOnDay() {
      return this.availableStayTypes.some(
        x => x.id === DietStayTypes.NightAddition
      );
    },
    stayTypeValidationRules() {
      if (this.stay.hasNightAddition) {
        return "";
      }

      return "required";
    },
    disabledDeductions() {
      return (
        (!this.stay.dietStayTypeId &&
          !this.stay.dietLengthTypeId &&
          this.stay.hasNightAddition) ||
        this.stayDurationType === DietDurationTypes.NotEligible
      );
    },
    disabledNightAddition() {
      if (!this.hasValidNightAdditionRateOnDay) {
        return true;
      }

      return (
        this.stay.dietStayTypeId === DietStayTypes.Hotel ||
        !this.durationIsOvernight ||
        !this.isEligible
      );
    },
    deductionTypes() {
      const that = this;
      return Object.values(DietDeductionTypes).map(function (val) {
        const label = that.$t(`enums.dietDeductionTypes.${val}`);
        const percentage = that.getDeductionTypePercentage(val, that.taxRates);

        return {
          text: `${label} ${percentage}`,
          value: val
        };
      });
    },
    stayDurationType() {
      const type = this.stayDurationTypes[
        m(this.stay.date).dayOfYear()
      ];
      if (type?.dietDurationType) {
        if (type.dietDurationType === DietDurationTypes.WithOvernight) {
          return type.dietDurationType;
        }

        if(this.durationTypeHasValidLengthType(type.dietDurationType)){
          return type.dietDurationType;
        }
      }

      return DietDurationTypes.NotEligible;
    },
    lengthType() {
      switch (this.stayDurationType) {
        case DietDurationTypes.SixToTwelveHours:
          return DietLengthTypes.SixToTwelveHours;
        case DietDurationTypes.Above12Hours:
          return DietLengthTypes.Above12Hours;
        default:
          return null;
      }
    },
    durationIsOvernight() {
      return this.stayDurationType === DietDurationTypes.WithOvernight;
    },
    isEligible() {
      return this.stayDurationType !== DietDurationTypes.NotEligible;
    }
  },
  watch: {
    "stay.dietStayTypeId": function (val) {
      if (val) {
        this.stay.dietLengthTypeId = null;

        if (val === DietStayTypes.Hotel) {
          this.stay.hasNightAddition = null;
        }
      } else if (this.stay.hasNightAddition) {
          this.stay.dietDeductionIds = [];
      }

      this.updateStayAmount();
    },
    "stay.dietLengthTypeId": function (val) {
      if (val) {
        this.stay.dietStayTypeId = null;
      }

      this.updateStayAmount();
    },
    "stay.dietDeductionIds": function () {
      this.updateStayAmount();
    },
    "stay.hasNightAddition": function (val) {
      if (val && !this.stay.dietStayTypeId) {
        this.stay.dietDeductionIds = [];
      }

      this.updateStayAmount();
    },
    stayDurationType(val) {
      if (!val || val === DietDurationTypes.NotEligible) {
        this.stay.dietDeductionIds = [];
        this.stay.dietLengthTypeId = null;
        this.stay.dietStayTypeId = null;
        this.stay.hasNightAddition = null;
        return;
      }

      this.updateDietLengthTypeId();
      this.updateStayAmount();
    },
    payingOrgs() {
      this.updateStayAmount();
    }
  },
  beforeMount() {
    this.updateDietLengthTypeId();
    this.updateStayAmount();
  },
  beforeUnmount() {
    this.stay.dietLengthTypeId = null;
    this.stay.dietStayTypeId = null;
    this.stay.stayDescription = null;
    this.stay.dietDeductionIds = [];
  },
  methods: {
    updateStayAmount() {
        this.stay.amount =
        calculateDietAmountForStay(
          this.stay,
          this.payingOrgs,
          this.salaryFraction
        );
    },
    updateDietLengthTypeId() {
      this.stay.dietLengthTypeId = this.lengthType;
    },
    filterEnabledDietStayTypes(conf) {
      return conf["dietRates"]["dietStayRateTypes"].filter(
        x => x.enabled && x.rate
      );
    },
    filterEnabledDietLengthTypes(conf) {
      return conf["dietRates"]["dietLengthRateTypes"].filter(
        x => x.enabled && x.rate
      );
    },
    durationTypeHasValidLengthType(durationType) {
      switch (durationType) {
        case DietDurationTypes.SixToTwelveHours:
          return this.availableLengthTypes.some(
            x => x.id === DietLengthTypes.SixToTwelveHours
          );
        case DietDurationTypes.Above12Hours:
          return this.availableLengthTypes.some(
            x => x.id === DietLengthTypes.Above12Hours
          );
        default:
          return false;
      }
    },
    getAsPercentIfNotZero(val) {
      if (val) {
        return`(${toPercent(val/100)})`;
      }

      return "";
    },
    getDeductionTypePercentage(val, taxRates) {
      switch (val) {
          case DietDeductionTypes.Breakfast:
            return this.getAsPercentIfNotZero(taxRates.breakfastDeductionRate);
          case DietDeductionTypes.Lunch:
            return this.getAsPercentIfNotZero(taxRates.lunchDeductionRate);
          case DietDeductionTypes.Dinner:
            return this.getAsPercentIfNotZero(taxRates.dinnerDeductionRate);
            default:
            return "";
        }
    }
  }
};
</script>

<style scoped>
.truncated {
  max-width: 200px;
}
</style>